module.exports = __webpack_public_path__ + "img/vip-level-3.52d3b5cc.png";